module.exports = __webpack_public_path__ + "static/media/detail_0028_t.1a982720.jpg";